import { PageActionOnValuesFunction } from '../types';
import { withdrawDeclaration } from './withdrawDeclaration';

const Withdraw: PageActionOnValuesFunction = {
    withdrawDeclaration,
};

export default Withdraw;
